<template>
  <div class="principal_home">
    <div id="header-part">
      <!-- <Header /> -->
    </div>

    <div class="mail-screen">

    </div>
    <!-- <Slideshow /> -->

  </div>
</template>

<script>
// import welcome_image from '../assets/welcome.png'

export default {
  name: "HelloWorld",
  components: {
  },
  data: () => ({
    novidades: [],
    procurados: [],
    campanhas: [],
    nome: "",
    email: "",
    telefone: "",
    text: "",
    mailed: false,
    error_message: "",
    propagandas: [],
    tinySliderOptions: {
        mouseDrag: true,
        loop: true,
        items: 4,
        glutter: 100,
      }
  }),
  async mounted() {
    this.getNovidades();
    this.getCampanhas();
    await this.getMaisProcurados();
    this.getPropagandas();
  },
  beforeMount() {},
  methods: {
    getNovidades() {
      this.$http
        .get("/opens/produtos/recents")
        .then((res) => {
          let subsprods = res.data;
          // console.log(subsprods);
          for (let e of subsprods) {
            if (e.image[0] && e.image[0].key) {
              e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;
            }
            let qntParcelas = 1;
            while (e.preco.preco_venda / qntParcelas > 50) {
              qntParcelas++;
            }

            e.qntParcelas = qntParcelas;
          }
          this.novidades = subsprods;
        })
        .catch(() => {});
    },
    async getMaisProcurados(){
      try{
        let procuradosmais = await this.$http.get("/opens/produto/mais/visualizacoes");
        let prod_ = procuradosmais.data;
        for (let e of prod_) {
            if (e.image[0] && e.image[0].key) {
              e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;
            }
            let qntParcelas = 1;
            while (e.preco.preco_venda / qntParcelas > 50) {
              qntParcelas++;
            }

            e.qntParcelas = qntParcelas;
          }
        
        this.procurados = prod_.slice(0, 9);
        
      } catch(err){
        console.log(err);
      }
    },
    getCampanhas() {
      this.$http
        .get("/opens/campanhas")
        .then((res) => {
          let camp_ = res.data;

          for (let e of camp_) {
            if (e.image && e.image.key) {
              //e.url = `http://localhost:3000/files/campanhas/${e.image.key}`;
              e.url = `https://api-store.emporiodasmarcas.com.br/files/campanhas/${e.image.key}`;
            }
          }

          this.campanhas = camp_;
        })
        .catch(() => {});
    },
    getPropagandas() {
      this.$http
        .get("/opens/propaganda")
        .then((res) => {
          let props_ = res.data;

          for (let e of props_) {

            if (e.image && e.image.key) {
              //e.url_img = `http://localhost:3000/files/propagandas/${e.image.key}`;
              e.url_img = `https://api-store.emporiodasmarcas.com.br/files/propagandas/${e.image.key}`;
            }
          }

          this.propagandas = props_;
        })
        .catch(() => {});
    },
    async realizarCadastroNovidade() {
      try {
        // if (this.email.length < 3) {
        //   this.error_message = "E-mail inválido!";
        // } else
        if (this.telefone.length < 10) {
          this.error_message = "Telefone inválido!";
        } else {
          await this.$http
            .post("/opens/notify-email-users/add", {
              nome: this.nome,
              // email: this.email,
              telefone: this.telefone,
            })
            .then(() => {
              this.mailed = true;
            })
            .catch((err) => {
              // console.log(err);
              return err;
            });
        }
      } catch (err) {
        this.error_message = "Verifique os dados informados!";
      }
    },
  },
};
</script>

<style>
.header-part{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.principal_home .mail-screen {
  background: url(../assets/welcome.png) no-repeat center center;
  width: 100vw;
  height: 50vw;
}

#campanha {
  width: 100%;
  height: 380px;
  object-fit: cover;
}

.new-product-carousel{
  width: 220px;
}

#block {
  height: 340px;
  width: 400px;
  display: inline-flex;
  margin-left: 10px;
  background-color: aquamarine;
}

#bloco_title {
  font-size: 30px;
  text-align: left;
  text-transform: uppercase;
}

#inputs {
  border-bottom: 1px solid #191919;
  height: 50px;
  margin-right: 5%;
  padding: 0px;
}

.dashboard-slider{
  display: flex;
}

#bloco_mail {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  width: 98%;
  border-radius: 10px;
  padding: 20px 100px;
  background-color: #fff;
}

#message {
  display: inline-flex;
  width: 30%;
}

#btn_quero {
  font-size: 20px;
  font-weight: 800;
  color: #ffffff;
  background-color: #191919;
  width: 20%;
  padding: 10px;
  border-radius: 20px;
  align-self: center;
}

#btn_quero:hover {
  background-color: #191919;
}

#inputs_mail {
  display: inline-flex;
}

#error_me {
  margin-top: 20px;
  font-size: 15px;
  color: darkorange;
}

#blocos {
  margin-top: 100px;
  display: inline-block;
  margin-bottom: 20px;
}

#mail_d {
  display: inline-flex;
}

#new {
  width: 100%;
  margin-left: 40px;
  margin-right: 40px;
}

#propaganda_ {
  height: 340px;
  width: 400px;
}

@media screen and (max-width: 800px) {
  .principal_home {
    width: 100%;
  }

  #carousel {
    height: 120px;
  }

  #bloco_mail {
    display: block;
    align-self: center;
    width: 100%;
    margin-top: 10px;
    border-radius: 10px;
  }

  #message {
    display: block;
    width: 90%;
  }

  #inputs {
    border-bottom: 1px solid #191919;
    height: 50px;
    margin-right: 5%;
    padding: 0px;
  }

  #mail_d {
    display: block;
    margin: 10px;
  }

  #btn_quero {
    font-size: 20px;
    font-weight: 800;
    color: #ffffff;
    background-color: #000;
    width: 100%;
    margin-top: 20px;
    padding: 10px;
    border-radius: 20px;
    align-self: center;
  }

  #inputs_mail {
    display: block;
  }

  #campanha {
    height: 180px;
  }

  #block {
    margin: 0;
    height: 340px;
    width: auto;
    display: inline-flex;
    background-color: white;
  }

  #slide {
    width: 100%;
  }

  #succ_mail {
    display: block;
    text-align: left;
  }

  #blocos {
    width: 100%;
    margin-top: 100px;
    display: inline-block;
    margin-bottom: 20px;
  }

  #propaganda_ {
    height: 300px;
    width: 100%;
    object-fit: contain;
  }

  #new {
    margin-left: 0px;
    width: 100%;
    background-color: white;
  }

  #carousel_infoProd {
    width: auto;
  }

  .dashboard-slider{
    display: flex;
    flex-direction: column;
  }

  .new-product-carousel{
    width: 90%;
  }
}
</style>